import { GlobalState } from '@leverege/ui-redux'

const toMutate = [ 'blueprint.link.location.bills.GroupScreen', 'blueprint.link.company.locations.bills.GroupScreen' ]
const personas = [ 'dealerLocationAdmin', 'dealeradmin', 'dealerEditor', 'dealerViewer' ]
export default function BillingLinkMutator( type, plugin ) {
  if ( type === 'Action' && toMutate.includes( plugin.id ) ) {
    return {
      ...plugin,
      handles : ( cxt ) => {
        const { clientProps : { match : { params }, actions : { systemId } } } = cxt
        // TODO: we don't have projectId, but its not likely to matter
        const resourceIds = ( [ params?.locationId, params?.companyId, systemId ] ).filter( a => a != null )
        const allRoles = GlobalState.get()?.ui?.allUserRoles
        const activePersona = GlobalState.get()?.ui?.activePersona?.name
        // check for new and old role
        if ( !personas.includes( activePersona ) ) {
          return plugin.handles( cxt )
        }
        const canSeeBilling = resourceIds.some( ( resourceId ) => {
          // we don't have permissions, so roles have to do
          // if you're locationAdmin or dealeradmin and have billingViewer you can see billing
          return allRoles?.[resourceId]?.roles?.some( r => r.name === 'billingViewer' )
        } )
        return plugin.handles( cxt ) && canSeeBilling
      }
    }
  }
  return plugin
}
